import { useDbClient } from "@tanstack/react-db";
import { useQuery } from "@tanstack/react-query";

import { prefetchWagsListings } from "./wags-listings";

const PREFETCH_STALE_TIME_MS = 5 * 60 * 1000;

export function usePrefetchListings(listingIds: string[]) {
    const dbClient = useDbClient();
    const prefetchKey = [...new Set(listingIds)].sort().join("|");

    return useQuery({
        queryKey: ["prefetch-listings", prefetchKey],
        queryFn: async () => {
            await prefetchWagsListings(dbClient, prefetchKey.split("|"));
            return null;
        },
        enabled: Boolean(prefetchKey),
        staleTime: PREFETCH_STALE_TIME_MS,
    });
}
